module.exports = __webpack_public_path__ + "img/g0R5.bd69c16a.gif";